"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.getAllowAccessPII = exports.getAccessDevMode = exports.getTenantId = exports.getProfilePicture = exports.getUserDetails = exports.setProfilePicture = exports.getTenantName = exports.setTenantName = exports.getAvailableProjects = exports.setAvailableProjects = exports.getTenantLevel = exports.setTenantLevel = exports.getAccessType = exports.setTenant = exports.setAccessType = exports.setTenantUrl = exports.getTenantUrl = exports.setTenantId = exports.setUserDetails = void 0;
var storage = require("../../utils/storage");
var constants_1 = require("../../constants");
/**
 * Set user details
 * @param {string} token
 */
function setUserDetails(data) {
    storage.setValueToLocalStorage(constants_1.USER_DETAILS, data);
}
exports.setUserDetails = setUserDetails;
/**
 * Set tenant id
 * @param {string} token
 */
function setTenantId(id) {
    storage.setValueToLocalStorage(constants_1.TENANT_ID, id);
}
exports.setTenantId = setTenantId;
/**
 * Get tenant url
 * @param {string} url
 */
function getTenantUrl() {
    return storage.getValueFromLocalStorage(constants_1.TENANT_URL);
}
exports.getTenantUrl = getTenantUrl;
/**
 * Set tenant url
 * @param {string} url
 */
function setTenantUrl(url) {
    return storage.setValueToLocalStorage(constants_1.TENANT_URL, url);
}
exports.setTenantUrl = setTenantUrl;
/**
 * Set tenant id
 * @param {string} token
 */
function setAccessType(accessType) {
    storage.setValueToLocalStorage(constants_1.ACCESS_TYPE, accessType);
}
exports.setAccessType = setAccessType;
function setTenant(data) {
    setTenantId(data.id);
    setTenantName(data.tenantName);
    setTenantUrl(data.url);
    setTenantLevel(data.tenantLevel);
    setAvailableProjects(data.availableProjects);
}
exports.setTenant = setTenant;
/**
 * @return {string}
 */
function getAccessType() {
    return storage.getValueFromLocalStorage(constants_1.ACCESS_TYPE);
}
exports.getAccessType = getAccessType;
function setTenantLevel(level) {
    storage.setValueToLocalStorage(constants_1.TENANT_LEVEL_KEY, level);
}
exports.setTenantLevel = setTenantLevel;
function getTenantLevel() {
    return storage.getValueFromLocalStorage(constants_1.TENANT_LEVEL_KEY);
}
exports.getTenantLevel = getTenantLevel;
function setAvailableProjects(availableProjects) {
    storage.setValueToLocalStorage(constants_1.AVAILABLE_PROJECTS, availableProjects);
}
exports.setAvailableProjects = setAvailableProjects;
function getAvailableProjects() {
    return storage.getValueFromLocalStorage(constants_1.AVAILABLE_PROJECTS);
}
exports.getAvailableProjects = getAvailableProjects;
/**
 * Set tenant name
 * @param {string} token
 */
function setTenantName(name) {
    storage.setValueToLocalStorage(constants_1.TENANT_NAME, name);
}
exports.setTenantName = setTenantName;
/**
 * Set tenant name
 * @param {string} token
 */
function getTenantName() {
    return storage.getValueFromLocalStorage(constants_1.TENANT_NAME);
}
exports.getTenantName = getTenantName;
/**
 * Set profile picture
 * @param {string} token
 */
function setProfilePicture(image) {
    storage.setValueToLocalStorage(constants_1.PROFILE_PICTURE, image);
}
exports.setProfilePicture = setProfilePicture;
/**
 * @return {string}
 */
function getUserDetails() {
    return storage.getValueFromLocalStorage(constants_1.USER_DETAILS);
}
exports.getUserDetails = getUserDetails;
/**
 * @return {string}
 */
function getProfilePicture() {
    return storage.getValueFromLocalStorage(constants_1.PROFILE_PICTURE);
}
exports.getProfilePicture = getProfilePicture;
/**
 * @return {string}
 */
function getTenantId() {
    // const userDetails = getUserDetails();
    // return userDetails.tenantId;
    return storage.getValueFromLocalStorage(constants_1.TENANT_ID);
}
exports.getTenantId = getTenantId;
function getAccessDevMode() {
    var _a;
    return (((_a = storage.getValueFromLocalStorage(constants_1.USER_DETAILS)) === null || _a === void 0 ? void 0 : _a.allowDevMode) || false);
}
exports.getAccessDevMode = getAccessDevMode;
function getAllowAccessPII() {
    var _a;
    return (((_a = storage.getValueFromLocalStorage(constants_1.USER_DETAILS)) === null || _a === void 0 ? void 0 : _a.allowAccessPII) || false);
}
exports.getAllowAccessPII = getAllowAccessPII;
/**
 * Make local storage empty
 */
function clear() {
    storage.clearLocalStorage();
}
exports.clear = clear;
//# sourceMappingURL=userDetails.js.map